module.exports = __webpack_public_path__ + "static/media/room-11.39cc01a3.jpg";